import type { HistoryResetResult } from '@inbound/contract';

import { apiSlice } from './api-slice.js';

export const maintenanceApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Clear call history so QA can re-run a scenario on a clean console.
     *
     * Available only where the API reports `testTools` on `/auth/me`; the route
     * answers 404 otherwise.
     *
     * The invalidation list is every tag the reset can empty: calls and
     * interactions, which the dashboard and the interactions page read, and
     * `Notification` because the lead alerts are gone and the bell would
     * otherwise keep showing them.
     */
    resetHistory: build.mutation<HistoryResetResult, void>({
      query: () => ({ url: '/maintenance/reset-history', method: 'POST' }),
      invalidatesTags: ['Call', 'Interaction', 'Notification'],
    }),
  }),
});

export const { useResetHistoryMutation } = maintenanceApi;
